import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfig } from '../../interfaces/environment.interface';
import {
  ActivityLogDto,
  ActivityLogOperatorPayload,
  ActivityLogPayload,
} from '../../types/activity-log.types';

@Injectable({ providedIn: 'root' })
export class ActivityLogsService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  public post(dto: ActivityLogDto): Observable<unknown> {
    const payload: ActivityLogPayload = {
      ...dto,
      platform: 'Platform UI',
      eventSource: dto.eventSource ?? 'user',
      origin: 'UI',
    };
    return this._http.post<ActivityLogPayload>(
      `${this._baseUrl}/activities/v2/surveys/${dto.surveyId}`,
      payload
    );
  }

  public postOperator(dto: ActivityLogOperatorPayload): Observable<unknown> {
    return this._http.post<ActivityLogPayload>(
      `${this._baseUrl}/activities/v2/operator`,
      {
        ...dto,
        origin: 'UI',
      }
    );
  }
}
